import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=e89eceac&"
import script from "./ProductItem.vue?vue&type=script&lang=ts&"
export * from "./ProductItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProductItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports